// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"1205387e","703":"cfd94694","787":"4d240774"}[chunkId] + ".chunk.js";
};